import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    youllPay: {
        id: '_.outstanding_view.youllPay',
        defaultMessage:
            ". You're paying {approvalInterestRate} interest per month."
    },
    tooltip: {
        id: '_.outstanding_view.tooltip',
        defaultMessage:
            'We charge interest by the day: that way, you only pay it for the days you have the loan.'
    }
});
